import { IntpWebsite } from '@va/aaas/shared/types';
import { createSelector } from 'reselect';

export const getIntpWebsiteInfo = (state: any) => state.getIn(['app'])?.intpWebsite as IntpWebsite | undefined;
export const getIntpResetDate = createSelector(getIntpWebsiteInfo, (websiteInfo) => websiteInfo?.stpResetAt);
export const getIntpName = createSelector(getIntpWebsiteInfo, (websiteInfo) => websiteInfo?.intpName);
